<div class="mat-dialog-container-in">
	<div class="dialog-box create-dialog-box {{custom_dialog_box}}">
		<div *ngIf="icon_class" class="dialog-icon {{icon_class}} {{marRight}}"></div>
		<div class="dialog-content">
			<h1 *ngIf="!warningDialog" mat-dialog-title [ngClass]="{'small_text':small_font}">{{text}}</h1>
      <div *ngIf="warningDialog" mat-dialog-content>
        <div  class="mat-dialog-content" [innerHtml]="warningDialog"></div>
      </div>
      <div [ngClass]="dialog_button_box">
        <button *ngIf="resetButt" class="reset-but" mat-dialog-close ="true">OK</button>
        <button *ngIf="routerlink != null && has_priv" mat-dialog-close [routerLink] = [routerlink] [ngClass]="ng_class" >{{ routerLinkText || 'OK'}}</button>
        <button *ngIf="routerlink == null && (!reset_event || !resetButt) "mat-dialog-close>OK</button>
      </div>
		</div>
	</div>
</div>
